import React from 'react';
import { Loader } from 'lucide-react';
import { Button } from './ui/button';

// Reusable Load More Button component
const LoadMoreButton = ({ onClick, loading, hasMore, totalShown }) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-8">
        <Loader className="w-6 h-6 animate-spin" style={{color: '#5D0F0F'}} />
        <span className="ml-3" style={{color: '#292021'}}>Loading more deals...</span>
      </div>
    );
  }
  
  if (hasMore) {
    return (
      <div className="flex justify-center py-8">
        <Button
          onClick={onClick}
          style={{backgroundColor: '#5D0F0F'}}
          className="hover:opacity-90 text-white px-8 py-3"
          data-testid="load-more-btn"
        >
          Load More Wines
        </Button>
      </div>
    );
  }
  
  if (totalShown > 0) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-600">You've seen all {totalShown} wine deals!</p>
      </div>
    );
  }
  
  return null;
};

export default LoadMoreButton;
